<template>
  <!-- workOrder_v5 §10 插单看板：插单 = 期望完成日 − 创建日 ≤ 2 个工作日；全工单状态；时间范围作用于创建时间；一包数据渲染全部区块 -->
  <div class="rush-board" v-loading="loading">
    <!-- tab 内筛选：插单天数 -->
    <div class="rb-bar">
      <span class="rb-bar-label">插单天数</span>
      <el-radio-group v-model="leadDays" size="mini" @change="fetch">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button label="0">当天插</el-radio-button>
        <el-radio-button label="1">提前1天</el-radio-button>
        <el-radio-button label="2">提前2天</el-radio-button>
      </el-radio-group>
      <span class="rb-note">插单 = 期望完成日 − 创建日 ≤ 2 个工作日（按 T+N 工作日口径，跳周末/节假日）；按创建时间落入上方时间范围；<b>含全部工单状态</b>（被驳回 / 已撤回也算「插过」），与其他 tab 数字不能直接对账；一单多集团 / 多媒体分别计入各自排行与矩阵格。</span>
    </div>

    <!-- KPI -->
    <div class="rb-kpis">
      <div class="rb-kpi"><div class="k">插单条数</div><div class="v">{{ kpi.orders }}</div><div class="s">素材需求 {{ kpi.material_num }} 条</div></div>
      <div class="rb-kpi"><div class="k">平均提前天数</div><div class="v" :class="kpi.orders ? leadCls(kpi.avg_lead) : ''">{{ kpi.orders ? fmtLead(kpi.avg_lead) : '—' }}</div><div class="s">工作日</div></div>
      <div class="rb-kpi"><div class="k">当天插单占比</div><div class="v">{{ kpi.same_day_rate || '0.0%' }}</div><div class="s">当天插 {{ kpi.same_day }} 单</div></div>
      <div class="rb-kpi"><div class="k">插单最多集团</div><div class="v ell" :title="kpi.top_bloc ? kpi.top_bloc.name : ''">{{ kpi.top_bloc ? kpi.top_bloc.name : '—' }}</div><div class="s">{{ kpi.top_bloc ? kpi.top_bloc.num + ' 单' : '' }}</div></div>
      <div class="rb-kpi"><div class="k">插单最多媒体</div><div class="v ell" :title="kpi.top_plat ? kpi.top_plat.name : ''">{{ kpi.top_plat ? kpi.top_plat.name : '—' }}</div><div class="s">{{ kpi.top_plat ? kpi.top_plat.num + ' 单' : '' }}</div></div>
    </div>

    <!-- 四张排行卡 -->
    <div class="rb-cards">
      <el-card class="rb-card" v-for="c in rankCards" :key="c.key">
        <div class="rb-card-title">{{ c.title }}<span class="rb-card-sub">{{ c.sub }}</span></div>
        <div v-if="!c.list.length" class="rb-empty">暂无数据</div>
        <div v-else class="rb-rank">
          <div v-for="(r, i) in c.list" :key="r.name" class="rb-row">
            <div class="rb-row-name" :title="r.name">{{ i + 1 }}. {{ r.name }}</div>
            <div class="rb-row-bar"><i :style="{ width: barPct(r.num, c.max) + '%' }" :class="c.key === 'lead' ? leadBarCls(r.lead) : ''"></i></div>
            <div class="rb-row-num">{{ r.num }}<span v-if="c.showPct" class="rb-row-avg">·{{ pctOf(r.num) }}%</span></div>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 集团 × 媒体 矩阵 -->
    <el-card class="rb-matrix">
      <div class="rb-card-title">集团 × 媒体 插单矩阵<span class="rb-card-sub">格内 = 工单数（一单多媒体分别计入）；行/列合计 = 该集团/媒体下的插单工单数与平均提前天数（悬停列合计数字可看来源） <i class="lg red">&lt;0.8 红</i><i class="lg yellow">&lt;1.4 黄</i><i class="lg green">其余 绿</i></span></div>
      <div v-if="!matrix.blocs.length" class="rb-empty">暂无数据</div>
      <div v-else class="rb-scroll">
        <table class="rb-table">
          <thead>
            <tr>
              <th class="rb-th-first">集团 ＼ 媒体</th>
              <th v-for="p in matrix.plats" :key="p" :title="p">{{ p }}</th>
              <th class="rb-th-tot">
                <el-tooltip placement="top" effect="light">
                  <div slot="content" class="rb-tip">
                    行合计 = 该集团下所有插单工单<br>
                    单数：一单多集团分别计入各自的集团行<br>
                    平均提前：这些工单的提前天数相加 ÷ 该行工单数
                  </div>
                  <span>行合计<i class="el-icon-question rb-q"></i></span>
                </el-tooltip>
              </th>
              <th class="rb-th-tot">
                <el-tooltip placement="top" effect="light">
                  <div slot="content" class="rb-tip">
                    平均提前（工作日）<br>
                    行 = 该集团下插单工单的提前天数之和 ÷ 工单数<br>
                    列 = 该媒体下插单工单的提前天数之和 ÷ 工单数<br>
                    右下角 = 全部插单工单去重后求平均
                  </div>
                  <span>平均提前<i class="el-icon-question rb-q"></i></span>
                </el-tooltip>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="b in matrix.blocs" :key="b">
              <td class="rb-td-first" :title="b">{{ b }}</td>
              <td v-for="p in matrix.plats" :key="b + '|' + p" class="rb-cell" :style="cellStyle(matrix.cells[b + '|' + p])">{{ matrix.cells[b + '|' + p] || '' }}</td>
              <td class="rb-td-tot">{{ rowTotal(b).num }}</td>
              <td class="rb-td-tot" :class="leadCls(rowTotal(b).avg_lead)">{{ fmtLead(rowTotal(b).avg_lead) }}</td>
            </tr>
            <tr class="rb-tr-tot">
              <td class="rb-td-first">
                <el-tooltip placement="top" effect="light">
                  <div slot="content" class="rb-tip">
                    列合计 = 该媒体下所有插单工单<br>
                    单数：一单多媒体分别计入各自的媒体列<br>
                    平均提前：这些工单的提前天数相加 ÷ 该列工单数<br>
                    悬停下方数字可看该媒体的集团构成
                  </div>
                  <span>列合计<i class="el-icon-question rb-q"></i></span>
                </el-tooltip>
              </td>
              <td v-for="p in matrix.plats" :key="'c_' + p" class="rb-td-tot">
                <el-popover placement="top" width="260" trigger="hover" :open-delay="150">
                  <div class="rb-tip">
                    <div class="rb-tip-h">{{ p }} · {{ colTotal(p).num }} 单 · 平均提前 {{ fmtLead(colTotal(p).avg_lead) }} 天</div>
                    <div class="rb-tip-list">
                      <div v-for="it in colBreakdown(p)" :key="it.bloc" class="rb-tip-row">
                        <span class="rb-tip-name" :title="it.bloc">{{ it.bloc }}</span>
                        <span class="rb-tip-num">{{ it.num }} 单</span>
                      </div>
                    </div>
                    <div class="rb-tip-foot">平均 = 该媒体下 {{ colTotal(p).num }} 单的提前天数之和 ÷ {{ colTotal(p).num }}</div>
                  </div>
                  <span slot="reference" class="rb-tot-ref">{{ colTotal(p).num }}</span>
                </el-popover>
              </td>
              <td class="rb-td-tot" title="总计按工单数（去重）">{{ matrix.total.num }}</td>
              <td class="rb-td-tot" :class="leadCls(matrix.total.avg_lead)">{{ fmtLead(matrix.total.avg_lead) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-card>

    <!-- 插单明细（聚合） -->
    <el-card class="rb-detail">
      <div class="rb-card-title">插单明细<span class="rb-card-sub">按 集团 + 媒体 + 游戏类型 + 素材类型 聚合</span>
        <el-button size="mini" icon="el-icon-download" class="rb-dl" :disabled="!detail.length" @click="downloadCsv">下载明细 CSV</el-button>
      </div>
      <!-- 2026-10-19 测试反馈：插单明细表格去掉排序 -->
      <el-table :data="detail" size="mini" border stripe max-height="420">
        <el-table-column prop="bloc" label="集团" min-width="160" show-overflow-tooltip />
        <el-table-column prop="plat" label="媒体" min-width="100" show-overflow-tooltip />
        <el-table-column prop="game" label="游戏类型" width="90" />
        <el-table-column prop="type" label="素材类型" width="90" />
        <el-table-column prop="num" label="工单数" width="90" sortable align="right" />
        <el-table-column prop="avg_lead" label="平均提前(工作日)" width="140" sortable align="right">
          <template slot-scope="{ row }"><span :class="leadCls(row.avg_lead)">{{ fmtLead(row.avg_lead) }}</span></template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 一句话总结 -->
    <div class="rb-summary" v-if="kpi.orders">{{ summaryText }}</div>
    <p class="rb-foot">说明：「插单」按工单<b>当前</b>期望完成日期判定（创建后被改过的按改后值算）；期望日早于创建日的记为当天插；无集团归「未知集团」，媒体无名称归「未知媒体」；制作人权限档只看得到已指派到本人的单。</p>
  </div>
</template>
<script>
import { debounce } from "lodash"
import API from "@/api/workOrder/board.js"

const EMPTY = () => ({
  kpi: { orders: 0, material_num: 0, avg_lead: 0, same_day: 0, same_day_rate: "0.0%", top_bloc: null, top_plat: null },
  by_bloc: [], by_plat: [], by_lead: [], by_type: [], by_game: [],
  matrix: { blocs: [], plats: [], cells: {}, row_total: {}, col_total: {}, total: { num: 0, avg_lead: 0 } },
  detail: [],
})
// 平均提前天数色阶（沿用业务 demo；工作日口径后数值整体偏大，阈值待业务看实际再调）
const LEAD_RED = 0.8
const LEAD_YELLOW = 1.4

export default {
  props: { form: { type: Object, default: () => ({}) } },
  data() {
    return { loading: false, leadDays: "", ...EMPTY() }
  },
  computed: {
    rankCards() {
      // 2026-10-21 对齐业务 demo：集团/媒体只出数量，不展示均值；天数分布/素材类型每行带占比
      const mk = (key, title, sub, list, showPct = false) => ({
        key, title, sub, showPct,
        list: list || [],
        max: Math.max(1, ...(list || []).map((i) => +i.num || 0)),
      })
      const typeCount = (name) => (this.by_type.find((t) => t.name === name) || {}).num || 0
      // demo 只展示视频/平面两行
      const typeList = this.by_type.filter((t) => t.name === "视频" || t.name === "平面")
      const has = !!this.kpi.orders
      return [
        mk("bloc", "集团插单量", has ? `${this.by_bloc.length} 个集团 · 共 ${this.kpi.orders} 条` : "", this.by_bloc),
        mk("plat", "媒体插单量", has ? `${this.by_plat.length} 个媒体` : "", this.by_plat),
        mk("lead", "插单天数分布", "越红越临时", this.by_lead, true),
        mk("type", "素材类型构成", has ? `视频 ${typeCount("视频")} · 平面 ${typeCount("平面")}` : "", typeList, true),
      ]
    },
    summaryText() {
      const top3 = this.by_bloc.slice(0, 3).map((b) => `${b.name}(${b.num})`).join("、")
      const plat = this.by_plat[0] ? `${this.by_plat[0].name} ${this.by_plat[0].num} 单` : "—"
      const n = this.kpi.orders || 1
      // IAP 占比用后端 by_game（工单去重）；detail 是 集团×媒体 聚合，一单多集团/多媒体会重复计，不能当分子
      const iap = (this.by_game.find((g) => g.name === "IAP") || {}).num || 0
      const video = (this.by_type.find((t) => t.name === "视频") || {}).num || 0
      const urgency = this.kpi.avg_lead < LEAD_RED ? "非常紧急" : this.kpi.avg_lead < LEAD_YELLOW ? "偏紧" : "相对从容"
      return `本期插单 ${this.kpi.orders} 单：插单最多的集团 ${top3 || "—"}；主力媒体 ${plat}；平均提前 ${this.fmtLead(this.kpi.avg_lead)} 个工作日（${urgency}），当天插单占 ${this.kpi.same_day_rate}；IAP 单占 ${Math.round((iap / n) * 100)}%，视频单占 ${Math.round((video / n) * 100)}%。`
    },
  },
  watch: {
    form: {
      handler: debounce(function () { this.fetch() }, 500),
      deep: true,
      immediate: true,
    },
  },
  methods: {
    fetch() {
      this.loading = true
      const params = {
        ...this.form,
        range_time: this.form.range_time?.length > 0 ? this.form.range_time.join("/") : "",
        lead_days: this.leadDays,
      }
      API.getRushBoard(params)
        .then((res) => {
          // 逐键赋值（与 capacityAnalysis 等 tab 一致），不把后端整包灌进 vm
          const d = res.data || {}
          const e = EMPTY()
          this.kpi = Object.assign(e.kpi, d.kpi || {})
          this.by_bloc = Array.isArray(d.by_bloc) ? d.by_bloc : []
          this.by_plat = Array.isArray(d.by_plat) ? d.by_plat : []
          this.by_lead = Array.isArray(d.by_lead) ? d.by_lead : []
          this.by_type = Array.isArray(d.by_type) ? d.by_type : []
          this.by_game = Array.isArray(d.by_game) ? d.by_game : []
          this.matrix = Object.assign(e.matrix, d.matrix || {})
          this.detail = Array.isArray(d.detail) ? d.detail : []
        })
        .catch((err) => { this.$message.error((err && err.info) || "插单看板加载失败") })
        .finally(() => { this.loading = false })
    },
    barPct(n, max) { return max > 0 ? Math.max(2, Math.round((n / max) * 100)) : 0 },
    fmtLead(v) { return v === null || v === undefined || v === "" ? "—" : Number(v).toFixed(2) },
    /** 当前插单总单数占比（与业务 demo 一致·四舍五入整数） */
    pctOf(num) { return this.kpi.orders ? Math.round((+num || 0) / this.kpi.orders * 100) : 0 },
    leadCls(v) { if (v === null || v === undefined || v === "") return ""; return v < LEAD_RED ? "lead-red" : v < LEAD_YELLOW ? "lead-yellow" : "lead-green" },
    leadBarCls(lead) { return lead === 0 ? "bar-red" : lead === 1 ? "bar-yellow" : "bar-green" },
    rowTotal(b) { return (this.matrix.row_total && this.matrix.row_total[b]) || { num: 0, avg_lead: null } },
    colTotal(p) { return (this.matrix.col_total && this.matrix.col_total[p]) || { num: 0, avg_lead: null } },
    /** 某媒体列下各集团贡献的插单工单数（悬停列合计展示来源） */
    colBreakdown(p) {
      const out = []
      Object.keys(this.matrix.cells || {}).forEach((k) => {
        const sep = k.lastIndexOf("|")
        if (sep < 0 || k.slice(sep + 1) !== p) return
        out.push({ bloc: k.slice(0, sep), num: +this.matrix.cells[k] || 0 })
      })
      return out.sort((a, b) => b.num - a.num || a.bloc.localeCompare(b.bloc))
    },
    cellStyle(n) {
      if (!n) return {}
      const max = Math.max(1, ...Object.values(this.matrix.cells || {}).map((v) => +v || 0))
      const a = 0.08 + 0.6 * (n / max)
      return { background: `rgba(85,127,238,${a.toFixed(2)})`, color: a > 0.45 ? "#fff" : "#303133" }
    },
    downloadCsv() {
      const head = ["集团", "媒体", "游戏类型", "素材类型", "工单数", "平均提前(工作日)"]
      const esc = (v) => `"${String(v === null || v === undefined ? "" : v).replace(/"/g, '""')}"`
      const lines = [head.map(esc).join(",")].concat(this.detail.map((r) => [r.bloc, r.plat, r.game, r.type, r.num, r.avg_lead].map(esc).join(",")))
      const blob = new Blob(["﻿" + lines.join("\n")], { type: "text/csv;charset=utf-8" })
      const a = document.createElement("a")
      a.href = URL.createObjectURL(blob)
      const rt = this.form.range_time && this.form.range_time.length ? this.form.range_time.join("_") : ""
      a.download = `插单明细_${rt || "本期"}${this.leadDays !== "" ? "_提前" + this.leadDays + "天" : ""}.csv`
      a.click()
      URL.revokeObjectURL(a.href)
    },
  },
}
</script>

<style scoped lang="scss">
.rush-board { font-size: 12px; color: #303133; }
.rb-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; background: #fff; border-radius: 5px; padding: 10px 12px; margin-bottom: 10px; }
.rb-bar-label { font-weight: 600; }
.rb-note { color: #909399; font-size: 11px; flex: 1 1 100%; }
.rb-kpis { display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px; margin-bottom: 10px; }
.rb-kpi { background: #fff; border-radius: 5px; padding: 10px 14px; .k { color: #909399; } .v { font-size: 22px; font-weight: 700; margin: 4px 0 2px; } .v.ell { font-size: 15px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; } .s { color: #a9afb9; font-size: 11px; } }
.rb-cards { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; margin-bottom: 10px; }
.rb-card ::v-deep(.el-card__body) { padding: 12px 14px; }
.rb-card-title { font-weight: 600; font-size: 13px; margin-bottom: 8px; display: flex; align-items: center; flex-wrap: wrap; gap: 6px; }
.rb-card-sub { color: #a9afb9; font-size: 11px; font-weight: 400; }
.rb-card-sub .lg { font-style: normal; margin-left: 4px; padding: 0 4px; border-radius: 3px; }
.rb-card-sub .lg.red { background: #fef0f0; color: #f56c6c; } .rb-card-sub .lg.yellow { background: #fdf6ec; color: #e6a23c; } .rb-card-sub .lg.green { background: #f0f9eb; color: #67c23a; }
.rb-empty { color: #c0c4cc; text-align: center; padding: 20px 0; }
.rb-rank { max-height: 260px; overflow: auto; }
.rb-row { display: flex; align-items: center; gap: 6px; margin-bottom: 5px; }
.rb-row-name { width: 38%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.rb-row-bar { flex: 1; height: 8px; background: #f0f2f5; border-radius: 4px; overflow: hidden; i { display: block; height: 100%; background: #557fee; border-radius: 4px; } i.bar-red { background: #f56c6c; } i.bar-yellow { background: #e6a23c; } i.bar-green { background: #67c23a; } }
.rb-row-num { width: 92px; text-align: right; font-weight: 600; white-space: nowrap; }
.rb-row-avg { font-weight: 400; color: #909399; margin-left: 4px; font-size: 11px; }
.rb-matrix, .rb-detail { margin-bottom: 10px; ::v-deep(.el-card__body) { padding: 12px 14px; } }
.rb-scroll { overflow: auto; max-height: 420px; }
.rb-table { border-collapse: collapse; width: 100%; th, td { border: 1px solid #ebeef5; padding: 4px 6px; text-align: center; white-space: nowrap; } th { background: #f5f7fa; font-weight: 600; position: sticky; top: 0; z-index: 1; } }
.rb-th-first, .rb-td-first { text-align: left !important; max-width: 220px; overflow: hidden; text-overflow: ellipsis; position: sticky; left: 0; background: #fff; z-index: 2; }
.rb-th-first { background: #f5f7fa; z-index: 3; }
.rb-td-tot, .rb-th-tot { font-weight: 600; background: #fafafa; }
.rb-tr-tot td { background: #f5f7fa; }
.rb-q { color: #a9afb9; cursor: help; margin-left: 2px; }
.rb-tot-ref { border-bottom: 1px dashed #a9afb9; }
.rb-tip { font-size: 12px; line-height: 1.7; color: #303133; }
.rb-tip-h { font-weight: 600; margin-bottom: 4px; }
.rb-tip-list { max-height: 200px; overflow-y: auto; padding-right: 4px; }
.rb-tip-row { display: flex; justify-content: space-between; gap: 12px; }
.rb-tip-name { max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.rb-tip-num { color: #606266; white-space: nowrap; }
.rb-tip-foot { color: #909399; font-size: 11px; border-top: 1px dashed #ebeef5; margin-top: 4px; padding-top: 4px; }
.rb-dl { margin-left: auto; }
.rb-summary { background: #eef5ff; border: 1px solid #d4e6ff; border-radius: 5px; padding: 10px 12px; margin-bottom: 8px; line-height: 1.6; }
.rb-foot { color: #a9afb9; font-size: 11px; margin: 0; }
.lead-red { color: #f56c6c; font-weight: 600; } .lead-yellow { color: #e6a23c; font-weight: 600; } .lead-green { color: #67c23a; font-weight: 600; }
</style>
